import Box from '@sendsprint/ui-react/dist/components/Box';
import Skeleton from '@sendsprint/ui-react/dist/components/Skeleton';
import Text from '@sendsprint/ui-react/dist/components/Text';
import React, { ReactNode } from 'react';
import StatusInfo from '../statusInfo';

interface Props {
  showExtraInfo?: boolean;
  label: string;
  value: ReactNode;
  processedValue?: ReactNode;
  pendingValue?: ReactNode;
  failedValue?: ReactNode;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
  errorText?: string;
}

const DashboardCard = ({
  showExtraInfo,
  label,
  failedValue,
  pendingValue,
  processedValue,
  value,
  isLoading,
  isError,
  refetch,
  errorText = 'Error fetching transaction information.'
}: Props) => {
  return (
    <Box className="ss-bg-white ss-rounded-lg md:ss-min-h-[200px] ss-p-4">
      <Text variant="paragraphSmall" className="ss-text-neutral-500">
        {label}
      </Text>
      {!isError && (
        <>
          {isLoading && <Skeleton className="ss-w-20 ss-h-12 ss-mt-2 ss-rounded" />}
          {!isLoading && (
            <Text variant="h5" className="ss-mt-2">
              {value}
            </Text>
          )}
          {showExtraInfo && (
            <>
              {isLoading && <Skeleton className="ss-rounded ss-mt-2" />}
              {isLoading && <Skeleton className="ss-rounded ss-mt-2" />}
              {!isLoading && (
                <Box className="ss-flex ss-gap-4 ss-flex-wrap ss-mt-2">
                  {(processedValue || processedValue === 0) && (
                    <StatusInfo variant="Processed" value={processedValue} />
                  )}
                  {(pendingValue || pendingValue === 0) && (
                    <StatusInfo variant="Pending" value={pendingValue} />
                  )}
                  {(failedValue || failedValue === 0) && (
                    <StatusInfo variant="Failed" value={failedValue} />
                  )}
                </Box>
              )}
            </>
          )}
        </>
      )}
      {isError && (
        <Box className="ss-mt-3 ss-flex ss-items-center ss-flex-wrap ss-gap-2">
          <Text variant="paragraphSmall">{errorText}</Text>
          <button
            type="button"
            onClick={refetch}
            className="focus:ss-focus-ring ss-rounded ss-underline ss-font-bold ss-text-paragraph-small">
            Retry
          </button>
        </Box>
      )}
    </Box>
  );
};

export default DashboardCard;
